const $$splitComponentImporter = () => import('/home/runner/work/graph-it/graph-it/apps/graphit/src/routes/_authed/admin.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { meQueryOptions } from '~/queries/me';
import { usersQueryOptions } from '~/queries/users';
export const Route = createFileRoute('/_authed/admin')({
  async beforeLoad({
    context
  }) {
    const me = await context.queryClient.ensureQueryData(meQueryOptions);
    if (!me.isAdmin) throw redirect({
      to: '/'
    });
  },
  loader: async ({
    context
  }) => context.queryClient.ensureQueryData(usersQueryOptions),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});